import * as CONST from "./actionTypes";

const initialState = {
  loading: false,
  success: false,
  error: null,
  registeredUser: null,
};

const RegisterReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CONST.REGISTER_ADMIN:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case CONST.REGISTER_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        registeredUser: payload?.data || null,
      };

    case CONST.REGISTER_ADMIN_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: payload || "Registration failed",
      };

    default:
      return state;
  }
};

export default RegisterReducer;
